import React from "react";
import { Switch } from "react-router-dom";
import Loadable from "react-loadable";
import {
    AppRoute,
    PrivateRoute,
    ContentManagerRoute,
    SuperAdminRoute
} from "./helpers/CustomRoutes";
import PermanentDrawer from "./components/PermanentDrawer";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV2";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import Loader from "./aGlobalDesign/Loader/Loader";

import Login from "./containers/Login";
import LoginCallback from "./containers/LoginCallback";
import LogoutCallback from "./containers/LogoutCallback";
import NotFound from "./containers/NotFound";

import Dashboard from "./containers/Dashboard/DashboardContainer";
import DashboardAgents from "./containers/Dashboard/DashboardAgents";
import DashboardClients from "./containers/Dashboard/DashboardClients";

import UsersContainer from "./containers/Administration/UsersContainer";
import Organisation from "./containers/Administration/OrganisationContainer";

import ContentsList from "./containers/Contents/ContentsList";
import ImportFiles from "./containers/Contents/ImportFiles";
import VideoMessagesList from "./containers/Contents/VideoMessagesList";
import Storage from "./containers/Contents/Storage";

import CallPanel from "./containers/CallGestion/Call/CallPanel";
import CallLog from "./containers/CallGestion/CallLog/CallLogContainer";
import URLCallsPermanent from "./containers/CallGestion/URLCalls/URLCallsContainer";
import Carousel from "./containers/CallGestion/Carousel/Carousel";
import WaitingList from "./containers/CallGestion/URLCalls/WaitingList";
import EditDecisionTree from "./containers/CallGestion/DecisionTrees/EditDecisionTree";

import ErrorReports from "./containers/SuperAdmin/ErrorReport/ErrorReportList";
import OrganizationsList from "./containers/SuperAdmin/Organizations/OrganizationsList";
import Organization from "./containers/SuperAdmin/Organizations/Organization";

import DisplaysContainer from "./containers/Monitoring/DisplaysContainer";

const theme = createTheme({
    palette: {
        primary: {
            main: "#904FED"
        },
        secondary: {
            main: "#EEEEEE"
        }
    }
});

// Lazy loaded routes
const ErrorReport = Loadable({
    loader: () => import("./containers/SuperAdmin/ErrorReport/ErrorReport"),
    loading: () => <Loader dimensions="40px" color={"var(--primary-base)"} />
});

export const routes
    = <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <PermanentDrawer>
                <Switch>
                    <PrivateRoute exact path="/" component={ Dashboard } />
                    <AppRoute path="/login" component={Login} />
                    <AppRoute path="/logincallback" component={LoginCallback} />
                    <AppRoute path="/logoutcallback" component={LogoutCallback} />

                    <PrivateRoute path="/Resources/ContentsList" component={ContentsList}/>
                    <ContentManagerRoute path="/Resources/ImportFiles" component={ImportFiles}/>
                    <PrivateRoute path="/Messages" component={VideoMessagesList}/>
                    <PrivateRoute path="/Storage" component={Storage}/>

                    <PrivateRoute path="/dashboard" component={Dashboard}/>
                    <PrivateRoute path="/dashboardAgents" component={DashboardAgents}/>
                    <PrivateRoute path="/dashboardClients" component={DashboardClients}/>
                    <PrivateRoute path="/callLink" component={CallPanel}/>

                    <PrivateRoute path="/callLog" component={CallLog}/>
                    <PrivateRoute path="/URLCalls" component={URLCallsPermanent}/>
                    <PrivateRoute path="/WaitingList" component={WaitingList}/>
                    <PrivateRoute path="/advertisement/Carousel" component={Carousel}/>

                    <PrivateRoute path="/Organisation" component={Organisation}/>
                    <PrivateRoute path="/Gestion/DecisionTree" component={EditDecisionTree}/>

                    <PrivateRoute path="/Gestion/Users" component={ UsersContainer } />

                    <PrivateRoute path="/Monitoring" component={ DisplaysContainer } />

                    <SuperAdminRoute path="/SuperAdmin/ErrorReportsList" component={ErrorReports} />
                    <SuperAdminRoute path="/SuperAdmin/ErrorReport" component={ErrorReport} />
                    <SuperAdminRoute path="/SuperAdmin/OrganizationsList" component={OrganizationsList} />
                    <SuperAdminRoute path="/SuperAdmin/Organization" component={Organization} />

                    <AppRoute component={NotFound} />
                </Switch>
            </PermanentDrawer>
        </LocalizationProvider>
    </ThemeProvider >
;
